const back_questions = [
  {
    question: "How is ##name## being evaluated today?",
    sub: "",
    type: "radio",
    telehealth: "form1[0].Page_1[0].HowExamCOnducted[0]",
    show: true,
    section: {
      page: "1",
      title: "Disability Benefits Questionnaire",
      number: "0",
    },
    questions: [
      {
        label: "How was the examination conducted?",
        title: "",
        subMain: "",
        sub: "",
        radioGroup: "form1[0].Page_1[0].RadioButtonList[3]",
        options: [
          {
            main: "In-Person Exam",
            dbqName: "1",
            sub: "",
          },
          {
            main: "Video Telehealth",
            dbqName: "2",
            sub: "",
          },
        ],
        answer: "In-Person Exam",
      },
    ],
  },
  {
    question: "Is ##name## regularly seen as a patient in your clinic?",
    sub: "",
    type: "yesno",
    show: true,
    section: {
      page: "1",
      title: "Disability Benefits Questionnaire",
      number: "0",
    },
    presidence: "Yes",
    radioGroup: "form1[0].Page_1[0].RadioButtonList[2]",
    ref: 0,
    dbqName_yes: "1",
    dbqName_no: "2",
    answer: "",
  },
  {
    question: "Did you review any of the patients records for this condition?",
    sub: "Please identify the evidence reviewed and the date range",
    type: "yesno",
    show: true,
    section: {
      page: "1",
      title: "Evidence reviewed",
      number: "0",
    },
    maxLength: 2000,
    presidence: "Yes",
    radioGroup: "form1[0].Page_1[0].RadioButtonList[0]",
    ref: 0,
    dbqName_yes: "2",
    dbqName_no: "1",
    answer: "",
    istext: true,
    textarea: false,
    placeholder: "Please identify the evidence reviewed and the date range",
    textdbqName: "form1[0].Page_1[0].IdentifyEvidence[0]",
    textanswer: "",
  },
  {
    question:
      "Select the statements that best represent the severity of the eating disorder",
    sub: "Check all that apply",
    type: "radioTiles",
    multi: true,
    show: true,
    small: true,
    section: {
      page: "2",
      title: "FINDINGS",
      number: "3",
    },
    note: "For VA purposes, an incapacitating episode is defined as a period during which bed rest and treatment by a physician are required.",
    cols: 2,
    questions: [
      {
        main: "Binge eating followed by measures to prevent weight gain",
        dbqName: "form1[0].#subform[1].FINDINGS[0]",
        answer: "",
      },
      {
        main: "Binge eating followed by self-induced vomiting",
        dbqName: "form1[0].#subform[1].FINDINGS[1]",
        answer: "",
      },
      {
        main: "Incapacitating episodes of more than two (2) but less than six (6) weeks total duration per year",
        dbqName: "form1[0].#subform[1].FINDINGS[2]",
        answer: "",
      },
      {
        main: "Incapacitating episodes of more than six (6) or more weeks total duration per year",
        dbqName: "form1[0].#subform[1].FINDINGS[3]",
        answer: "",
      },
      {
        main: "Incapacitating episodes of up to two (2) weeks total duration per year",
        dbqName: "form1[0].#subform[1].FINDINGS[5]",
        answer: "",
      },
      {
        main: "Requiring Hospitalization more than twice a year for parenteral nutrition (Intravenous)",
        dbqName: "form1[0].#subform[1].FINDINGS[4]",
        answer: "",
      },
      {
        main: "Requiring Hospitalization more than twice a year for tube feeding",
        dbqName: "form1[0].#subform[1].FINDINGS[8]",
        answer: "",
      },

      {
        main: "Resistance to weight gain even when below expected minimum weight",
        dbqName: "form1[0].#subform[1].FINDINGS[9]",
        answer: "",
      },
      {
        main: "Self-induced weight loss to less than 80 percent of expected minimum weight",
        dbqName: "form1[0].#subform[1].FINDINGS[6]",
        answer: "",
      },
      {
        main: "Self-induced weight loss to less than 85 percent of expected minimum weight",
        dbqName: "form1[0].#subform[1].FINDINGS[10]",
        answer: "",
      },
      {
        main: "Without incapacitating episodes",
        dbqName: "form1[0].#subform[1].FINDINGS[7]",
        answer: "",
      },
    ],
    answer: "",
  },

  {
    question: "Does this Disability impair ##name##'s ability to work?",
    sub: "",
    type: "yesno",
    show: true,
    section: {
      page: "3",
      title: "FUNCTIONAL IMPACT",
      number: "5",
    },
    maxLength: 1000,
    presidence: "Yes",
    ref: 0,
    dbqName_yes: "form1[0].Page_2[0].Yes2[0]",
    dbqName_no: "form1[0].Page_2[0].No2[0]",
    answer: "",
    istext: true,
    textarea: false,
    placeholder: "Please describe impact, providing one or more examples)",
    textdbqName: "form1[0].Page_2[0].DescribeImpact[0]",
    textanswer: "",
  },
  {
    question: "Additional Comments",
    sub: "",
    optional: true,
    type: "textarea",
    maxLength: 1500,
    show: true,
    section: {
      page: "3",
      title: "REMARKS",
      number: "5",
    },
    options: [],
    dbqName: "form1[0].Page_2[0].REMARKS[0]",
    answer: "",
  },
];

export default back_questions;
